<div class="ui-g ui-fluid">
    <div class="ui-g-12">
        <!-- Left Side -->
        <div class="card card-w-title">

            <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-2">
                    <label><b>Consultation Type</b></label>
                    <p-dropdown id="dropdown" [options]="consultations" [disabled]="this.posting"
                        [(ngModel)]="query.consultation_type_id" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class="ui-g-12 ui-md-2">
                    <label><b>Country</b></label>
                    <p-dropdown id="dropdown" class="notranslate" [options]="countries" [disabled]="this.posting"
                        [(ngModel)]="query.country_id" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class=" ui-md-2">
                    <label><b>Transaction Status</b></label>
                    <p-dropdown id="dropdown" [disabled]="this.posting" [options]="status_list"
                        [(ngModel)]="this.query.status" (onChange)="GetTransactions(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class="ui-g-12 ui-md-2">
                    <label><b>Specialty</b></label>
                    <p-dropdown id="dropdown" class="notranslate" [options]="specialties" [disabled]="this.posting"
                        [(ngModel)]="query.specialty_id" (onChange)="GetTransactions(null)" [filter]="true"
                        [showClear]="true" [filterBy]='"label"'>
                    </p-dropdown>
                </div>
                <div class="ui-g-12 ui-md-2">
                    <label><b>Doctor</b></label>

                    <p-dropdown [(ngModel)]="this.query.user_guid" class="notranslate" [options]="doctor_list" [filter]="true"
                        name="doctors" #doctors="ngModel" (onChange)="GetTransactions(null)" defaultLabel="Doctor"
                        [disabled]="this.posting">
                    </p-dropdown>
                </div>
                <div class="ui-g-12 ui-md-2" style="padding-top: 30px;">
                    <p-checkbox [(ngModel)]="disabledDates" [disabled]="this.posting"
                        (onChange)="query.from_date=null; query.to_date=null; GetTransactions(null);"
                        [binary]="true"></p-checkbox>
                    <label style="padding-left:3px;font-style:bold">Disable Dates?</label>
                </div>
                <div class="ui-g-12 ui-md-2">

                    <label><b>From:</b></label>
                    <p-calendar class="notranslate" [showIcon]="true" [disabled]="disabledDates || this.posting" [maxDate]="this.maxDate"
                        placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="1900:2099" [(ngModel)]="query.from_date"
                        (ngModelChange)="GetTransactions(null)"></p-calendar>
                </div>
                <div class="ui-g-12 ui-md-2">
                    <label><b>To:</b></label>
                    <p-calendar [showIcon]="true" class="notranslate" [disabled]="disabledDates || posting" [minDate]="query.from_date"
                        [maxDate]="this.maxDate" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="1900:2099" [(ngModel)]="query.to_date"
                        (ngModelChange)="GetTransactions(null)"></p-calendar>
                </div>

                <div class="ui-md-4" style="padding-top: 30px;">
                    <p-progressSpinner [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                        *ngIf="this.posting" strokeWidth="6"></p-progressSpinner>
                    <button pButton type="submit" label="Reset" [disabled]="this.posting"
                        style="margin-bottom:10px;margin-right:5px;width:160px;" (click)="InitFilter(true)"></button>
                    <button pButton type="submit" label="Download CSV" icon="pi pi-download" (click)="getDownloadData()"
                        [disabled]="this.posting" style="width:160px;color:#004aad;background-color: white;"
                        iconPos="right"></button>
                </div>



                <div class="ui-g-12 ui-md-12" style="color: red;" *ngIf="ErrorMessage!=null">
                    <p>{{ErrorMessage}}</p>
                </div>
                <div class="ui-md-12" style="color: red;" *ngIf="invalid_date_message">
                    <p>Please select the From date and To date</p>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="card no-margin">
    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
        <p-table #patients [value]="Transactions" dataKey="id" styleClass="p-datatable-customers"
            [loading]="this.loading" [lazy]="true" [rows]="this.query.records_per_page" [totalRecords]="total_records"
            (onLazyLoad)="GetTransactions($event)" [paginator]="true" [showCurrentPageReport]="true"
            [(first)]="this.query.first" [scrollable]="true" [autoLayout]="true" [rowsPerPageOptions]="[10,25,50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr class="trentry">
                    <th style="width: 70px;" pSortableColumn="sr_no"><b>Sr No</b> </th>

                    <th pSortableColumn="doctor_name"><b>Doctor Name</b> </th>

                    <th pSortableColumn="consultation"><b>Consultation Type</b> </th>

                    <th pSortableColumn="specialty_name"><b>Speciality</b> </th>

                    <th pSortableColumn="created_at"><b>Date</b> </th>

                    <th pSortableColumn="patient_name"><b>Patient Name</b> </th>

                    <th pSortableColumn="country_name"><b>Country</b> </th>

                    <th pSortableColumn="transaction_no"><b>Transaction Number</b> </th>

                    <th pSortableColumn="status"><b>Transaction Status</b> </th>

                    <th pSortableColumn="rendered_actual_amount"><b>Actual Amount</b> </th>

                    <th pSortableColumn="rendered_amount"><b>Paid Amount</b> </th>

                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-trans>
                <tr [pSelectableRow]="trans" class="trentry">
                    <td style="width: 70px;">
                        <span>{{trans.sr_no}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.doctor_name}}</span>
                    </td>
                    <td>

                        <span>{{trans.consultation}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.specialty_name}}</span>
                    </td>
                    <td>

                        <span>{{trans.created_at | date: 'medium'}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.patient_name}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.country_name}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.transaction_no}}</span>
                    </td>
                    <td>

                        <span>{{trans.transaction_status}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.rendered_actual_amount}}</span>
                    </td>
                    <td>

                        <span class="notranslate">{{trans.rendered_amount}}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr class="trentry">
                    <td colspan="4">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>
    </div>
</div>
<div class="wrapper">

    <button pButton type="button" label="Back" [routerLink]="['/',this.slug,'doctor']" style="margin-bottom:10px;margin-right:5px;"
        class="ui-button-info ui-button-rounded"></button>
</div>